export default __webpack_public_path__ + "static/media/person-20.90a36bc6.svg";